import { SwitchButton } from 'components-ref/atoms'

interface WithCheckboxProps {
    section?: string
    title?: string
    switchActive?: boolean
    switchFn?: any
}

const WithCheckbox = ({
    section,
    title,
    switchActive,
    switchFn
}: WithCheckboxProps) => {
    return (
        <>
            <h2 className='layoutHeader__section'>{section}</h2>
            <h1 className='layoutHeader__title'>
                {title}
                <SwitchButton active={!!switchActive} toggle={switchFn} />
            </h1>
        </>
    )
}

export default WithCheckbox
